import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/reverse-complement/pages/CalculatorPage";

export const Route = createFileRoute("/reverse-complement")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.revcomp_meta_title() },
      { name: "description", content: m.revcomp_meta_description() },
      { property: "og:title", content: m.revcomp_meta_title() },
      { property: "og:description", content: m.revcomp_meta_description() },
      ...i18nOgMeta("/reverse-complement"),
    ],
    links: [...i18nLinks("/reverse-complement")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.sci_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.revcomp_tool_name(),
              item: localeUrl(`/reverse-complement`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            { q: m.revcomp_faq_q1(), a: m.revcomp_faq_a1() },
            { q: m.revcomp_faq_q2(), a: m.revcomp_faq_a2() },
            { q: m.revcomp_faq_q3(), a: m.revcomp_faq_a3() },
            { q: m.revcomp_faq_q4(), a: m.revcomp_faq_a4() },
          ].map(({ q, a }) => ({
            "@type": "Question",
            name: q,
            acceptedAnswer: { "@type": "Answer", text: a },
          })),
        }),
      },
    ],
  }),
  component: CalculatorPage,
});
